import { render, staticRenderFns } from "./DonationHome.vue?vue&type=template&id=10fa89e7&scoped=true"
import script from "./DonationHome.vue?vue&type=script&lang=js"
export * from "./DonationHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa89e7",
  null
  
)

export default component.exports